var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('div',{staticClass:"container extra--padding mb-4"},[_c('page-loading',{attrs:{"show":_vm.loading}}),_c('featured-agent-buy')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }